import React, { useRef, useState, useEffect } from 'react';
import { SurveyQuestion } from './SurveyQuestion';
import SignatureCanvas from 'react-signature-canvas';

export const SurveySignature = ({ option, hasVoted, onOptionUpdated }) => {
    const sigCanvasRef = useRef(null);
    const [isTyping, setIsTyping] = useState(option.textValue && !option.textValue?.startsWith('data:image')); // Default to typing if not an image
    const [textValue, setTextValue] = useState(option.textValue?.startsWith('data:image') ? '' : option.textValue || ''); // Initialize with stored value

    // Prepopulate the signature canvas when option.textValue is an image
    useEffect(() => {
        if (option.textValue?.startsWith('data:image') && sigCanvasRef.current) {
            sigCanvasRef.current.fromDataURL(option.textValue); // Load the saved signature
        }
    }, [option.textValue]);

    // Disable or enable drawing based on hasVoted
    useEffect(() => {
        if (hasVoted && sigCanvasRef.current) {
            sigCanvasRef.current.off(); // Disable drawing
        } else if (sigCanvasRef.current) {
            sigCanvasRef.current.on(); // Enable drawing
        }
    }, [hasVoted]);

    const handleEnd = () => {
        if (sigCanvasRef.current) {
            const signatureData = sigCanvasRef.current.toDataURL(); // Get signature as data URL
            onOptionUpdated(option.ballotOptionId, signatureData);
        }
    };

    const handleClear = () => {
        if (isTyping) {
            setTextValue('');
            onOptionUpdated(option.ballotOptionId, '');
        } else if (sigCanvasRef.current) {
            sigCanvasRef.current.clear();
            onOptionUpdated(option.ballotOptionId, '');
        }
    };

    const handleToggleInput = () => {
        setIsTyping(!isTyping);
    };

    const handleTextChange = (event) => {
        setTextValue(event.target.value);
        onOptionUpdated(option.ballotOptionId, event.target.value);
    };

    return (
        <>
            <SurveyQuestion option={option} />
            <div className="border-gray-300 rounded border-2 p-2">
                {isTyping ? (
                    <input
                        type="text"
                        value={textValue}
                        onChange={handleTextChange}
                        disabled={hasVoted}
                        className="w-full border-0 rounded-none border-b border-black text-4xl py-4 max-w-2xl h-24 focus:outline-none focus:ring-0"
                        placeholder="Type your signature"
                        style={{ fontFamily: "'Dancing Script', cursive" }}
                    />

                ) : (
                    <SignatureCanvas
                        ref={sigCanvasRef}
                        penColor="black"
                        canvasProps={{
                            className: 'w-full border-b border-black max-w-2xl h-24',
                            disabled: hasVoted,
                        }}
                        onEnd={handleEnd}
                    />
                )}

                {!hasVoted && (
                    <div className="mt-2">
                        <button type="button" className="btn btn-slim" onClick={handleClear}>
                            Clear
                        </button>
                        <button type="button" className="ml-2 btn btn-slim" onClick={handleToggleInput}>
                            {isTyping ? 'Sign' : 'Type'}
                        </button>
                    </div>
                )}
            </div>
        </>
    );
};